import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import config from 'config';
import { db } from 'firebase/fbConfig';
import { updateUserData } from 'store/actions/userActions';
import ActionableSongListItem from 'components/ActionableSongListItem.jsx';
import MessageInfo from 'components/MessageInfo';

const ActionableSongList = ({
  uid,
  data,
  listType,
  listLength,
  favoriteSongs,
  updateUserData,
}) => {
  const [list, setList] = useState([]);

  useEffect(() => {
    if (data) setList(data);
  }, []);

  const toggleIsFavorite = async (item) => {
    // Is this song still in the favorites?
    const found = favoriteSongs.find((e) => e.id === item.id);
    // If not then add it, if it is then remove it from the list
    const list = !!found
      ? favoriteSongs.filter((e) => e.id !== item.id)
      : favoriteSongs.concat(item);
    // Persist new favorites list in db
    await db
      .collection(config.db.userCollection)
      .doc(uid)
      .set({ favoriteSongs: list }, { merge: true });
    // Persist new favorites list in app state
    updateUserData({ favoriteSongs: list });
  };

  if (!list.length) {
    return <MessageInfo text="No tracks found" />;
  }

  return list
    .slice(0, listLength || list.length)
    .map((e, i) => (
      <ActionableSongListItem
        key={e.title}
        data={e}
        index={i}
        listType={listType}
        inFavorites={favoriteSongs.find((it) => it.id === e.id)}
        toggleIsFavorite={toggleIsFavorite}
      />
    ));
};

ActionableSongList.defaultProps = {
  favoriteSongs: [],
};

const mapStateToProps = (state) => {
  const { uid } = state.user || {};
  const { favoriteSongs } = state.user || {};
  return { uid, favoriteSongs };
};

export default connect(
  mapStateToProps,
  { updateUserData }
)(ActionableSongList);
